import { render, staticRenderFns } from "./AnswerDetails.vue?vue&type=template&id=da3236de&"
import script from "./AnswerDetails.vue?vue&type=script&lang=js&"
export * from "./AnswerDetails.vue?vue&type=script&lang=js&"
import style0 from "./AnswerDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports